import {
  DashboardIcon,
  OrganizationIcon,
  ProjectsIcon,
  SettingsIcon,
} from "@hero-app/components/ui/icons/nav-icons";
import { cn } from "@hero-app/lib/utils";

const NAV_ITEMS = [
  { label: "Dashboard", icon: DashboardIcon, active: true },
  { label: "Projects", icon: ProjectsIcon, active: false },
  { label: "Organization", icon: OrganizationIcon, active: false },
  { label: "Settings", icon: SettingsIcon, active: false },
] as const;

export function SidebarNav() {
  return (
    <div className="shrink-0 px-2">
      <nav className="flex flex-col overflow-hidden rounded-card border-[0.5px] border-[#e3e6e8] bg-[#FFFFFF80]">
        {NAV_ITEMS.map(({ label, icon: Icon, active }, index) => (
          <div
            key={label}
            className={cn(
              "flex h-[26px] items-center gap-1.5 px-2",
              index > 0 && "shadow-[inset_0_0.5px_0_0_#e3e6e8]",
              !active && "text-black/30",
            )}
          >
            <Icon className={cn("size-2.5 shrink-0", !active && "opacity-70")} />
            <span className={cn("text-[10px]", !active && "opacity-70")}>{label}</span>
          </div>
        ))}
      </nav>
    </div>
  );
}
